import { combineReducers } from "redux";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IListBuilderDetailsDto } from "../interface/dto/list-builder-details.dto";
import {
    ListBuilderActionType,
    IListBuilderActions,
} from "./list-builder-form-page.action";
import {
    IListBuilderListState,
    listBuilderListReducer,
} from "./list-builder-list.reducer";

export interface IListBuilderState {
    data?: IListBuilderDetailsDto;
    isLoading: boolean;
    saveSuccess: boolean;
    error?: string;
    saveError?: IErrorDto;
}

const initialListBuilderState: IListBuilderState = {
    isLoading: false,
    saveSuccess: false,
};

export const listBuilderReducer = (
    state = initialListBuilderState,
    action: IListBuilderActions,
): IListBuilderState => {
    switch (action.type) {
        case ListBuilderActionType.LIST_BUILDER_RESET_SAVE_FLAG:
            return {
                ...state,
                isLoading: false,
                saveSuccess: false,
                data: undefined,
                saveError: undefined,
                error: undefined,
            };
        case ListBuilderActionType.LIST_BUILDER_GET_DETAILS:
        case ListBuilderActionType.LIST_BUILDER_SAVE:
            return {
                ...state,
                isLoading: true,
                saveSuccess: false,
            };
        case ListBuilderActionType.LIST_BUILDER_GET_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case ListBuilderActionType.LIST_BUILDER_GET_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };
        case ListBuilderActionType.LIST_BUILDER_SAVE_ERROR:
            return {
                ...state,
                isLoading: false,
                saveError: action.payload.error,
            };
        case ListBuilderActionType.LIST_BUILDER_SAVE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                saveSuccess: true,
            };
        default:
            return state;
    }
};

export const listBuilderPageReducer = combineReducers({
    listBuilderList: listBuilderListReducer,
    listBuilder: listBuilderReducer,
});

export interface IListBuilderPageState {
    listBuilderList: IListBuilderListState;
    listBuilder: IListBuilderState;
}
